const WorkSetting = ({
  naviSearch,
  setNaviSearch
}) => {
  const togglePreferences = (type) => {
    const display = type === naviSearch.type ? 'block' : 'none';
    return {display};
  };
  return (
    <div className="walk-options route-option-group" style={togglePreferences('walk')}>
      <div className="option-item">
        <input type="radio" id="walk-condition-0" name="walk_condition" value="0" checked={naviSearch.walk.psc === 0}
          onChange={() => setNaviSearch({...naviSearch, walk: {...naviSearch.walk, psc: 0}})} />
        <label htmlFor="walk-condition-0">距離が短い</label>
      </div>
      <div className="option-item">
        <input type="radio" id="walk-condition-5" name="walk_condition" value="5" checked={naviSearch.walk.psc === 5}
          onChange={() => setNaviSearch({...naviSearch, walk: {...naviSearch.walk, psc: 5}})} />
        <label htmlFor="walk-condition-5">屋根が多い</label>
      </div>
      <div className="option-item">
        <input type="radio" id="walk-condition-3" name="walk_condition" value="3" checked={naviSearch.walk.psc === 3}
          onChange={() => setNaviSearch({...naviSearch, walk: {...naviSearch.walk, psc: 3}})} />
        <label htmlFor="walk-condition-3">階段が少ない</label>
      </div>
    </div>
  );
};

export default WorkSetting;